<template>
    <IncodeCapture v-if="isMobile" v-bind="propsWithListenerAttrs" />
    <IncodeDelegationForm v-else v-bind="propsWithListenerAttrs" :delegation-title="delegationTitle" />
</template>

<script lang="ts">
    import { Component, Prop } from 'vue-property-decorator';

    import { isSelfieImageAttributeType, isVideoSelfieAttributeType } from '@evidentid/ido-lib/curation/videoSelfie';

    import IncodeCapture from '@/components/fields/IncodeCapture.vue';
    import IncodeDelegationForm from '@/components/fields/IncodeDelegationForm.vue';
    import support from '@/config/support';
    import FieldComponent from '@/fields/FieldComponent';

    @Component({
        inheritAttrs: false,
        components: { IncodeCapture, IncodeDelegationForm },
    })
    export default class IncodeView extends FieldComponent<any> {
        @Prop({ type: Boolean, default: support.isMobileBrowser })
        private isMobile!: boolean;

        private get delegationTitle(): string {
            const attrType = this.question?.attrType || '';
            if (isVideoSelfieAttributeType(attrType) || isSelfieImageAttributeType(attrType)) {
                return 'Use your mobile phone to take a selfie';
            }
            return 'Use your mobile phone to scan your ID';
        }
    }
</script>
